const productionDatabaseURL = "https://vrcore-6845f.firebaseio.com";
const stagingDatabaseURL = "https://vrcore-staging.firebaseio.com";
const databaseURL =
    process.env.REACT_APP_PRODUCTION_BUILD === "YES"
        ? productionDatabaseURL
        : stagingDatabaseURL;
const firebaseConfig = {
    apiKey: "AIzaSyCz0SHjmxIttABl_afstF5fQm4iH834xN4",
    authDomain: "vrcore-6845f.firebaseapp.com",
    databaseURL,
    projectId: "vrcore-6845f",
    storageBucket: "vrcore-6845f.appspot.com",
    messagingSenderId: "415150274289"
};

export default firebaseConfig;
